import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@kuroo/widgets";
import "@kuroo/ui/tokens.css";
import "@kuroo/ui/ui.css";
import { applyThemePreference } from "@kuroo/ui";
import { PortalApp } from "./App";
import "./styles.css";

applyThemePreference();

createRoot(document.getElementById("root")!).render(<StrictMode><PortalApp /></StrictMode>);
